import React, { FC, useState } from 'react';
import { Form } from 'react-bootstrap';
import ChromePicker from 'react-color';

export interface Props {
  value: string | undefined;
  onChange: (event: string | undefined) => void;
  isShown?: boolean | undefined;
}

const ColorInput: FC<Props> = ({ value, isShown, onChange }: Props) => {
  const [show, setShow] = useState<boolean>(isShown || false);
  const [color, setColor] = useState<string>(value || '#000000');

  return (
    <div className="color-input">
      <Form.Control readOnly type="text" onClick={() => setShow(!show)} value={color} data-testid="colorInput-input" />
      {show && (
        <div className="color-popover">
          <div className="color-backdrop" onClick={() => setShow(false)} data-testid="colorInput-backdrop" />
          <ChromePicker
            color={color}
            onChange={(newColor) => {
              setColor(newColor.hex);
              onChange(newColor.hex);
            }}
          />
        </div>
      )}
    </div>
  );
};

export default ColorInput;
